module.exports = __webpack_public_path__ + "img/11.95444471.jpg";